export const BLOCK_HORIZONTAL_MARGIN = 24
export const BLOCK_VERTICAL_MARGIN = 12
export const HEADER_FOOTER_HEIGHT = 72
